"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Menu = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Menu = function Menu() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.083 8.084H4.917a.417.417 0 01-.417-.417v-.833c0-.23.187-.417.417-.417h14.166c.23 0 .417.187.417.417v.833c0 .23-.186.417-.417.417zm.417 4.583v-.833a.417.417 0 00-.417-.417H4.917a.417.417 0 00-.417.417v.833c0 .23.187.417.417.417h14.166c.23 0 .417-.187.417-.417zm0 4.167v.833c0 .23-.186.417-.417.417H4.917a.417.417 0 01-.417-.417v-.833c0-.23.187-.417.417-.417h14.166c.23 0 .417.187.417.417z",
    clipRule: "evenodd"
  });
};

exports.Menu = Menu;